import * as types from './mutation-types'
import {cacheManager} from "@/services/cacheManagerjs";

export const loadTimeZones = ({commit, state}) => {
    return new Promise((resolve, reject) => {
        cacheManager.fetch('get/timeZone/collection', state.timeZones)
            .then((response) => {
                if(!response.fromState) commit(types.LOAD_TIME_ZONES, response.data);
                resolve(response)
            })
            .catch((err) => {
                reject(err)
            })
    })
}